import {fromJson, JsonReviver} from '@peachy/utility-kit-pure'
import {map, Observable} from 'rxjs'

export const mapFromJson =
    <T>(jsonReviver?: JsonReviver) =>
        (o: Observable<string>): Observable<T> =>
            o.pipe(map(json => fromJson(json, jsonReviver) as T))
